/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-04 15:01:48
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-11-28 15:14:18
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SiderErrorController/SiderNameWithErr/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Icon } from '@/src/tools/icon';
import { useSelector } from 'react-redux';
import { getErrorState } from '../slice';

const NameWithErr = (props) => {
  const { name, id } = props;
  const err = useSelector(getErrorState(id));

  return (
    <div className={css.container}>
      {name}
      {id && err && <Icon type='iconinfo1' className={css.icon} />}
    </div>
  );
};
export default NameWithErr;
